import { createSelector } from 'reselect';

const getLanguageHelper = (state) => state.config?.language;

export const getLanguage = createSelector(
    [getLanguageHelper],
    (language) => (language)
);
